import { Button, Table, Upload } from 'antd';
import React from 'react'
import {OutTable, ExcelRenderer} from 'react-excel-renderer';
import { UploadOutlined } from '@ant-design/icons'
import { useState } from 'react';

const ExcelRender = ({header, setHeader, cols, setCols}) => {

    const handleFile = (event) => {
        console.log(event.file);
        const file = event.file
        ExcelRenderer(file, (err, response) => {
            if(err){
                console.log(err)
            }else{
                setHeader(response.rows[0])
                setCols(response.rows)
            }
        })
    }
    // ["id","name"]
    // let data ={

    // }
    // data[header[i]] =cols[i][j]
    // push (data)
return (
    <>
    <Upload beforeUpload maxCount={1} onChange={handleFile} >
        <Button icon={<UploadOutlined />}>Файл оруулах</Button>
    </Upload>
    <div className='relative overflow-auto border mt-4 sm:rounded-lg h-[519px]'>
        <table className="w-full text-sm text-left text-slate-100 dark:text-black overflow-auto">
            <thead className="text-xs text-slate-100 uppercase bg-gray-50 dark:bg-slate-100 dark:text-slate-100">
                <tr>
                    {header.map((h, i) => (
                        <th scope='col' class="px-6 py-3 bg-gray-50 dark:bg-green-800" key={i}>{h}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {cols.slice(1).map((col, i) => (
                    <tr className='bg-white border-b dark:bg-slate-100 dark:border-gray-300' key={i}>
                        {col.map((c, i) => (
                            <td className="px-6 py-4" key={i}>{c}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
    </>
  )
}

export default ExcelRender